<template>
	<ui-modal
		name="select-origin-for-deal"
		:load-success="loader.modalLoadSuccess"
		:load="loader.modalLoad"
		title="Selecione a origem do negócio"
		icon="fal fa-sitemap"
		size="xs"
	>
        <div class="modal-content">
            <ui-select-2
                v-model="deal.origin_id"
                :data="originOptions"
                :loading="loader.origin"
                required
                search
                :add-selecteds="canAddOption"
                size="md"
                label="Origem do negócio"
                item-label="label"
                return-value="id"
            />
        </div>

		<template #footer  >
            <div class="buttons">
                <ui-button type="button" design="md link cancel-button" >
                    Cancelar
                </ui-button>
                <ui-button
                    type="button"
                    design="md success mw-100"

                    :disabled="!canSubmit"
                    @click="submit"
                >
                    Salvar
                </ui-button>
            </div>
		</template>
	</ui-modal>
</template>
<script>
    import { uiModal } from '@/components/ui/modal'
    import { uiSelect2 } from "@/components/ui/form"
    import { uiButton } from '@/components/ui/buttons'

    import {
        origins,
        funnel,
        configuration
    } from '@/services/axios'

    const defaultLoader = () => ({
        modalLoad: false,
        modalLoadSuccess: false,
        origin: false
    })

    const defaultDeal = () => ({
        customer_id: null,
        product_id: null,
        cost: null,
        funnel_stage_id: null,
        funnel_stage_status_id: null,
        broker_id: null,
        manager_id: null,
        team_id: null,
        origin_id: null,
    })

    export default {
        components: {
            uiModal,
            uiSelect2,
            uiButton,
        },

        data() {
            return {
                loader: { ...defaultLoader() },
                deal: { ...defaultDeal() },
                client: null,
                originOptions: [],
                canAddOption: false,
            }
        },

        mounted() {
            this.$root.$on('modal-open-select-origin-for-deal', (data) => {
                this.loader = { ...defaultLoader() }
                this.deal   = { ...defaultDeal() }

                this.deal = { ...data.deal, origin_id: null }
                this.client = { ...data.client }

                this.loader.origin = true
                /** Carrega as origens possíveis de um cliente */
                origins.getOrigins('user').then(response => {
                    this.originOptions = response.data
                }).catch(error => {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                }).finally(() => {
                    this.loader.origin = false
                })

                configuration.getConfigurations().then(response => {
                    let data = response.data
                    let config = null
                    for (var prop in data) {
                        if(data.hasOwnProperty(prop)) {
                            switch (data[prop].name) {
                                case 'customerTags':
                                    config = data[prop].value_long
                                    if (config && config.insert === 'active')
                                        this.canAddOption = true
                                    break
                            }
                        }
                    }
                })
            })
        },

        computed: {
            canSubmit() {
                return this.deal.origin_id != null && this.deal.origin_id != undefined && !Array.isArray(this.deal.origin_id)
            },
        },

        beforeDestroy() {
            this.loader = { ...defaultLoader() }
            this.deal = { ...defaultDeal() }
            this.client = null

            this.$root.$off('modal-open-select-origin-for-deal')
        },

        methods: {
            async submit() {
                this.loader.modalLoad = true
                if (isNaN(parseInt(this.deal.origin_id)))  await this.createOrigin()

                /** Cria o negócio vinculado ao cliente */
                funnel.createDeal(this.deal)
                    .then(response => {
                        if (response.data && response.data.msg) this.$toastr.s(response.data.msg)
                        this.$emit('selected', {
                            client: this.client,
                            deal: response.data.data
                        })

                        setTimeout(() => {
                            this.$set(this.loader, 'modalLoadSuccess', true)

                            setTimeout(() => {
                                this.$root.$emit('modal-close-select-origin-for-deal')
                            }, 404)
                        }, 404)
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                    })
            },

            async createOrigin() {
				const origin = {
					slug: this.form.data.origin,
					type: 'System',
				}

				const response = await origins.createV2('', origin)
				this.originOptions.push(response.data)
				this.deal.origin_id = response.data.id
            }
        }
    }
</script>
<style>

</style>